import styled from '@emotion/styled';

const TransparentButton = styled.button`
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}` : '16px')};
  background-color: transparent;
  padding: 8px 0;
  color: ${(props) => (props.color ? props.color : '#667085')};
  cursor: pointer;
  border: none;
  outline: none;
  /* transition: all 0.1s linear; */
  display: flex;
  justify-content: ${(props) => (props.justifyContent ? `${props.justifyContent}` : 'center')};
  align-items: ${(props) => (props.alignItems ? `${props.alignItems}` : 'center')};
  gap: 5px;
  width: ${(props) => (props.width ? `${props.width}` : 'auto')};
  text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};
  /* box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05); */
  &:hover {
    opacity: 0.95;
  }
  &:active {
    transform: scale(0.95);
  }
  &:disabled {
    color: #bdbdbd;
    background: transparent;
    cursor: not-allowed;
  }
`;

export default TransparentButton;
